import React, { useState } from "react";
import DropDown from "./../components/admin/DropDown";
import InputField from "../components/admin/InputField";
import Button from "../components/UI/Button";
import { Link } from "react-router-dom";
import { useAppContext } from "../context/appContext";

const AddItem = () => {
    const { addNewItem } = useAppContext();

    const [itemName, setItemName] = useState("");

    const setItemNameHandler = (e) => {
        setItemName(e.target.value);
    };
    const [itemPrice, setItemPrice] = useState("");

    const setItemPriceHandler = (e) => {
        setItemPrice(e.target.value);
    };

    const [dropdownValue, setDropdownValue] = useState("");

    const setDropdownValueHandler = (value) => {
        setDropdownValue(value);
    };

    const options = [
        { id: 1, name: "Starters", unavailable: false },
        { id: 2, name: "Mains", unavailable: false },
        { id: 3, name: "Sides", unavailable: false },
        { id: 4, name: "Desserts", unavailable: false },
        { id: 5, name: "Soft drinks", unavailable: false },
        { id: 6, name: "Cocktails", unavailable: false },
        { id: 7, name: "Wines", unavailable: false },
        { id: 8, name: "Spirits", unavailable: false },
    ];

    const onSubmitHandler = (e) => {
        e.preventDefault();
        if (itemName === "" || itemPrice === "" || dropdownValue === "") {
            //alert("Please fill all the fields");
            return;
        }
        addNewItem({
            name: itemName,
            price: itemPrice,
            type: dropdownValue,
        });
        setItemName("");
        setItemPrice("");
        setDropdownValue("");
    };

    return (
        <div className='flex min-h-[35rem] w-full max-w-[50rem] flex-col rounded-lg bg-main-800'>
            <div className='h-auto w-full rounded-t-lg bg-slate-100 p-4 font-semibold text-main-900'>
                <h1 className='text-2xl  '>
                    Item Management -{" "}
                    <Link to={"/admin/items/"}>
                        <span className='mx-1 cursor-pointer rounded-md border-2 border-main-800 bg-main-800 p-1 text-xl text-white'>
                            Add item
                        </span>
                    </Link>
                    <Link to={"/admin/items/edit"}>
                        <span className='cursor-pointer text-xl'> Edit / Delete item</span>
                    </Link>
                </h1>
            </div>
            <div className='m-8'>
                <form onSubmit={onSubmitHandler}>
                    <div className='mb-6 grid gap-6 md:grid-cols-2'>
                        <InputField
                            type={"text"}
                            name={"Item name"}
                            value={itemName}
                            handleChange={setItemNameHandler}
                        />
                    </div>

                    <div className='mb-6'>
                        <InputField
                            type={"number"}
                            name={"Price"}
                            value={itemPrice}
                            handleChange={setItemPriceHandler}
                        />
                    </div>
                    <div className='max-w-[20rem] pb-4'>
                        <DropDown
                            name={"Item"}
                            options={options}
                            onValueChange={setDropdownValueHandler}
                        />
                    </div>

                    <div>
                        <Button label={"Submit"} />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddItem;
